export function ListCard({
  children,
  borderless,
}: {
  children: React.ReactNode;
  borderless?: boolean;
}) {
  const borderClass = borderless ? "" : "border border-slate-300";

  return (
    <div className={`overflow-y-auto rounded-lg ${borderClass}`}>
      {children}
    </div>
  );
}

export default function Card({
  header,
  children,
}: {
  header: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <div className="rounded-lg border border-slate-300 bg-white">
      {header && (
        <div className="px-4 py-3 border-b border-slate-300">{header}</div>
      )}
      <div className="px-4 py-3">{children}</div>
    </div>
  );
}
